import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { deleteBrandApi } from '../../api/endpoints';

// Initial state
const initialState = {
  status: '', // loading, success, error
  data: null,
  message: '',
};

// Async thunks for CREATE operations
export const deleteBrand = createAsyncThunk('deleteBrand', async (payload) => {
  return await deleteBrandApi(payload);
});

const deleteBrandSlice = createSlice({
  name: 'deleteBrand', // Unique Name
  initialState,
  reducers: {
    deleteBrandReset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(deleteBrand.pending, (state) => {
        state.status = 'loading';
        state.data = {};
      })
      .addCase(deleteBrand.fulfilled, (state, action) => {
        const { message = '', data = {}, payload = null } = action.payload;
        state.status = 'success';
        state.message = message;
        state.data = data || payload;
      })
      .addCase(deleteBrand.rejected, (state, action) => {
        const { message } = action.error || {};
        state.status = 'error';
        state.message = message;
      });
  },
});
export const { deleteBrandReset } = deleteBrandSlice.actions;

export default deleteBrandSlice.reducer;
